const TEXT_TYPES = ["textbox", "vectortext", "caption"];

const TYPE_DISPLAY_NAMES: Record<string, string> = {
  textbox: "Text",
  vectortext: "Curved Text",
  image: "Image",
  video: "Video",
  audio: "Audio",
  vector: "Shape",
  grid: "Grid",
  table: "Table",
  table2: "Table",
  qrcode: "QR Code",
  line: "Line",
  caption: "Caption",
  group: "Group",
  background: "Background"
};

function stripHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

/**
 * Returns a human-readable label for an element, suitable for display in the
 * "Select Layer" context menu submenu.
 */
export function getElementLabel(element: {
  name?: string;
  value?: string;
  type: string;
}): string {
  // For text elements, use stripped HTML value
  if (TEXT_TYPES.includes(element.type) && element.value) {
    const text = stripHtml(element.value).trim();
    if (text) {
      return text.length > 30 ? text.slice(0, 30) + "\u2026" : text;
    }
  }

  // Use element name if available
  if (element.name) {
    return element.name;
  }

  // Fall back to type display name
  return TYPE_DISPLAY_NAMES[element.type] || element.type;
}
